import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { ConfirmTimeModel } from '../../../models';
import { Button, DialogActions, Grid, Stack, TextField } from '@mui/material';
import { padZeroToStart } from '../../../utils';

export type ElectricityRequirementTimeDialogProps = {
    onOK: (data: any) => void;
    onCancel: () => void;
    initialValue: any;
};

export const ElectricityRequirementTimeDialog = (props: ElectricityRequirementTimeDialogProps) => {
    const {onOK, onCancel, initialValue } = props;
    
    const { control, handleSubmit, formState: { errors }, setValue } = useForm<ConfirmTimeModel>({
        mode: 'all',
        criteriaMode: "all",
        defaultValues: initialValue,
    });

    // Cancelボタンイベント
    const handleCancel = () => {
        onCancel();
    };

    const handleEditSubmit = (data:any) => {
        onOK(data);
    }

    const handleInputOnBlur = (e: any, name: any, maxLength: number) => {
        setValue(name, padZeroToStart(e.target.value, maxLength));
    }

    return (
        <div>
            
                <Dialog open={true} maxWidth={"md"} fullWidth>
                    <form onSubmit={handleSubmit(handleEditSubmit)} style={{ width: '90%', margin: 'auto' }}>
                        <DialogTitle>電力量要求</DialogTitle>
                        <DialogContent sx={{ pb: 1.5 }}>
                            <Stack spacing={2.5} style={{ marginLeft: '10px', width: '98%', position:"relative" }}>
                                <Grid container spacing={1}>
                                    <Grid item xs={2}>
                                        <Controller
                                            control={control}
                                            name="year"
                                            rules={{ required: '必須項目です。入力してください。',
                                                pattern: {
                                                    value: /^[0-9]{1,2}$/,
                                                    message: '00～99'
                                                }
                                            }}
                                            render={({ field }) => (
                                                <>
                                                    <TextField
                                                        {...field}
                                                        fullWidth
                                                        type="number"
                                                        label={`年`}
                                                        size="small"
                                                        error={!!errors?.year}
                                                        helperText={errors?.year?.message}
                                                        inputProps={{
                                                            maxLength:2
                                                        }}
                                                        onBlur={(e) => { handleInputOnBlur(e,"year",2)}}
                                                    />
                                                </>
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={3}></Grid>

                                    <Grid item xs={2}>
                                        <Controller
                                            control={control}
                                            name="month"
                                            rules={{ required: '必須項目です。入力してください。',
                                                pattern: {
                                                    value: /^(?:[1-9]|0[1-9]|1[0-2])$/,
                                                    message: '01～12'
                                                }
                                            }}
                                            render={({ field }) => (
                                                <>
                                                    <TextField
                                                        {...field}
                                                        fullWidth
                                                        type="number"
                                                        label={`月`}
                                                        size="small"
                                                        error={!!errors?.month}
                                                        helperText={errors?.month?.message}
                                                        inputProps={{
                                                            maxLength:2
                                                        }}
                                                        onBlur={(e) => { handleInputOnBlur(e,"month",2)}}
                                                    />
                                                </>
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={3}></Grid>

                                    <Grid item xs={2}>
                                        <Controller
                                            control={control}
                                            name="day"
                                            rules={{ required: '必須項目です。入力してください。',
                                                pattern: {
                                                    value: /^(?:0?[1-9]|[1-2][0-9]|3[01])$/,
                                                    message: '01～31'
                                                }
                                            }}
                                            render={({ field }) => (
                                                <>
                                                    <TextField
                                                        {...field}
                                                        fullWidth
                                                        type="number"
                                                        label={`日`}
                                                        size="small"
                                                        error={!!errors?.day}
                                                        helperText={errors?.day?.message}
                                                        inputProps={{
                                                            maxLength:2
                                                        }}
                                                        onBlur={(e) => { handleInputOnBlur(e,"day",2)}}
                                                    />
                                                </>
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1}>
                                    <Grid item xs={2}>
                                        <Controller
                                            control={control}
                                            name="hour"
                                            rules={{ required: '必須項目です。入力してください。',
                                                pattern: {
                                                    value: /^(?:0?[0-9]|1[0-9]|2[0-3])$/,
                                                    message: '00～23'
                                                }
                                            }}
                                            render={({ field }) => (
                                                <>
                                                    <TextField
                                                        {...field}
                                                        fullWidth
                                                        type="number"
                                                        label={`時`}
                                                        size="small"
                                                        error={!!errors?.hour}
                                                        helperText={errors?.hour?.message}
                                                        inputProps={{
                                                            maxLength:2
                                                        }}
                                                        onBlur={(e) => { handleInputOnBlur(e,"hour",2)}}
                                                    />
                                                </>
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={3}></Grid>

                                    
                                    <Grid item xs={2}>
                                        <Controller
                                            control={control}
                                            name="minute"
                                            rules={{ required: '必須項目です。入力してください。',
                                                pattern: {
                                                    value: /^(?:0?[0-9]|[1-4][0-9]|5[0-9])$/,
                                                    message: '00～59'
                                                }
                                            }}
                                            render={({ field }) => (
                                                <>
                                                    <TextField
                                                        {...field}
                                                        fullWidth
                                                        type="number"
                                                        label={`分`}
                                                        size="small"
                                                        error={!!errors?.minute}
                                                        helperText={errors?.minute?.message}
                                                        inputProps={{
                                                            maxLength:2
                                                        }}
                                                        onBlur={(e) => { handleInputOnBlur(e,"minute",2)}}
                                                    />
                                                </>
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                            </Stack>
                        </DialogContent>
                        <DialogActions>
                            <Stack direction='row' justifyContent="flex-end" spacing={2} sx={{ mt: 2, mr: 2,mb: 2 }}>
                                <Button color="inherit" variant="contained" onClick={handleCancel}>キャンセル</Button>
                                <Button variant="contained" type="submit">実行</Button>
                            </Stack>
                        </DialogActions>
                    </form>
                </Dialog>
        </div>
    );
}

export default ElectricityRequirementTimeDialog;